<template>
  <i-box :fixed="fixedHeight">
    <span slot="title" v-if="!hideTitle">
      <slot name="title">
        <h3>Title</h3>
      </slot>
    </span>
    <span slot="heading" v-if="!hideDescription">
      <slot name="description">
        Description
      </slot>
    </span>
    <span slot="content">
      <slot name="content"></slot>
    </span>
  </i-box>
</template>

<script>
import IBox from '@/components/common/IBox';

export default {
  name: 'ProfileDashboardCard',
  components: {
    IBox,
  },
  props: {
    fixedHeight: {
      type: Boolean,
      default: true,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
    hideDescription: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// DashboardSectionCard.vue?1bddd55d